const TermsAndConditions = () => {
  return (
    <>
      <div className="max-w-5xl mx-auto px-4 py-12 font-poppins text-gray-800">
        {/* Main heading */}
        <h1 className="text-4xl font-bold mb-4">Terms & Conditions</h1>

        {/* Subtitle */}
        <p className="text-xl font-medium text-gray-700 mb-10">
          By using our services, you agree to these terms and conditions.
        </p>

        <hr className="mb-10" />

        {/* Introduction paragraph */}
        <p className="mb-6">
          Lentera Technologies provides services that are subject to these terms
          and conditions. By using our services, you agree to be bound by this
          Agreement, which governs your use of the services provided by Lentera
          Technologies. If you do not agree with these terms, you may not access
          or use our services.
        </p>

        {/* 1. Use of Services */}
        <h2 className="text-xl font-semibold mt-8 mb-3">1. Use of Services</h2>
        <p className="mb-6">
          You may use our services solely for lawful purposes and in accordance
          with this Agreement. You agree not to engage in any activity that
          violates any applicable laws or regulations.
        </p>

        {/* 2. Third-Party Content */}
        <h2 className="text-xl font-semibold mt-8 mb-3">
          2. Third-Party Content
        </h2>
        <p className="mb-6">
          Our services may provide links or access to third-party websites or
          content. We do not endorse or have control over such third-party sites
          or content. Your use of third-party sites or content is at your own
          risk, and you should review the terms and privacy policies of those
          sites.
        </p>

        {/* 3. Intellectual Property */}
        <h2 className="text-xl font-semibold mt-8 mb-3">
          3. Intellectual Property
        </h2>
        <p className="mb-6">
          The content, features, and functionality provided by our services,
          including but not limited to text, graphics, logos, images, and
          software, are owned by or licensed to Lentera Technologies and are
          protected by copyright, trademark, and other intellectual property
          laws. You agree not to copy, modify, transfer, or distribute our
          services or any part thereof without our prior written consent.
        </p>

        {/* 4. Limitation of Liability */}
        <h2 className="text-xl font-semibold mt-8 mb-3">
          4. Limitation of Liability
        </h2>
        <p className="mb-6">
          In no event shall Lentera Technologies or its affiliates be liable to
          you or any third party for any direct, indirect, incidental,
          consequential, or punitive damages arising out of or in connection
          with your use of our services, even if we have been advised of the
          possibility of such damages.
        </p>

        {/* 5. Indemnification */}
        <h2 className="text-xl font-semibold mt-8 mb-3">5. Indemnification</h2>
        <p className="mb-6">
          You agree to indemnify and hold Lentera Technologies and its
          affiliates harmless from any claims, losses, damages, liabilities, or
          expenses, including reasonable attorneys' fees, arising out of or in
          connection with your use of our services or any violation of this
          Agreement.
        </p>

        {/* 6. Entire Agreement */}
        <h2 className="text-xl font-semibold mt-8 mb-3">6. Entire Agreement</h2>
        <p className="mb-6">
          This Agreement constitutes the entire agreement between any individual
          or organisation and Lentera Technologies regarding the subject matter
          herein and supersedes all prior or contemporaneous agreements,
          understandings, or representations.
        </p>

        {/* 7. Contact Us */}
        <h2 className="text-xl font-semibold mt-8 mb-3">7. Contact Us</h2>
        <p className="mb-6">
          If you have any questions, concerns, or requests regarding this
          Agreement, please contact us using the information provided on our
          website.
        </p>

        {/* Acknowledgment */}
        <p className="mt-10">
          By accessing or using our services, you acknowledge that you have
          read, understood, and agreed to be bound by this Agreement.
        </p>
      </div>
    </>
  );
};

export default TermsAndConditions;
